import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";

type ColumnDef = {
  key: string;
  labelKey: string;
  width?: number;
};

type Props = {
  columns: ColumnDef[];
  fileName: string;
};

export const ExportExcelGeneric = forwardRef<ExcelExport, Props>(
  ({ columns, fileName }, ref) => {
    const { t } = useTranslation();
    return (
      <ExcelExport ref={ref} fileName={fileName}>
        {columns.map((c) => (
          <ExcelExportColumn
            key={c.key}
            field={c.key}
            title={t(c.labelKey)}
            width={c.width || 150}
            headerCellOptions={{
              background: "#235592",
              color: "#fff",
            }}
          />
        ))}
      </ExcelExport>
    );
  },
);
